import { ReactElement, ReactNode } from 'react';

interface FormEntryProps {
  label: string;
  children: ReactNode;
}

// ReactElement rather than JSX.Element: React 19 removed the global JSX
// namespace, and ReactElement is what the rest of the components use anyway.
export default function FormEntry({ label, children }: FormEntryProps): ReactElement {
  return (
    <>
      <label className="cr-font-main cr-font-medium cr-ml-4 cr-mr-4 cr-mt-1 cr-text-base">{label}</label>
      <div className="cr-m-2 cr-font-main cr-text-base">{children}</div>
    </>
  );
}
